import Vue from "vue";
import Router from "vue-router";
import { loginLineUser } from "@/config/line-service-login";
import { checkLineUser } from "@/config/line-service";
import { checkUserExist } from "./config/login-service";
import store from "../src/store/";
import { logVisit, getProfileNPS } from "@/config/general-function";
import {
  addParamAndReloadViaLine,
  exchangeTokenThirdParty,
  reloadViaLine,
} from "./config/general-function";
// import i18n from "./plugins/i18n";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "",
      component: () => import("@/layouts/blank-layout/Blanklayout"),
      meta: { layout: "Blanklayout" },
      children: [
        // ========== ========== Page Login ========== ==========
        {
          name: "check-login",
          path: "/",
          component: () => import("@/layouts/blank-layout/Blanklayout"),
          beforeEnter: checkLineUser,
          meta: {
            roleUser: [""],
            visitLog: {},
            unauthenticated: true,
          },
        },
        {
          name: "login",
          path: "login",
          component: () => import("@/views/Customer/Login/LoginLineWithOutOtp"),
          beforeEnter: loginLineUser,
          meta: {
            roleUser: [""],
            visitLog: {},
            unauthenticated: true,
          },
        },
        {
          name: "login-line",
          path: "login-line",
          component: () => import("@/views/Customer/Login/LoginLine"),
          beforeEnter: loginLineUser,
          meta: {
            roleUser: [""],
            visitLog: {},
            unauthenticated: true,
          },
        },
        {
          name: "login-bypass",
          path: "login-bypass",
          component: () => import("@/views/Customer/Login/CheckNumberOtp"),
          beforeEnter: checkLineUser,
          meta: {
            roleUser: ["Customer"],
            visitLog: {},
            unauthenticated: true,
          },
        },

        // ========== ========== Page Register ========== ==========
        {
          name: "register-bypass",
          path: "register-bypass",
          component: () => import("@/views/Customer/Login/RegisterPhone"),
          beforeEnter: checkLineUser,
          meta: {
            roleUser: [""],
            visitLog: {},
            unauthenticated: true,
          },
        },

        // ========== ========== Page Check Number ========== ==========
        {
          name: "checknumberLine",
          path: "checknumberLine",
          component: () => import("@/views/Customer/Login/CheckNumberLine"),
          meta: {
            roleUser: ["Customer"],
            visitLog: {},
            unauthenticated: true,
          },
        },
        {
          name: "checknumberGoogle",
          path: "checknumberGoogle",
          component: () => import("@/views/Customer/Login/CheckNumberGoogle"),
          meta: {
            roleUser: ["Customer"],
            visitLog: {},
            unauthenticated: true,
          },
        },

        // ========== ========== Page For Main ========== ==========
        {
          name: "select-profile",
          path: "select-profile",
          component: () => import("@/views/Customer/Member/SelectProfile"),
          meta: {
            roleUser: ["Customer"],
            visitLog: {},
          },
        },
        {
          name: "search",
          path: "search",
          component: () => import("@/components/searchPage"),
          meta: {
            roleUser: ["Customer"],
            visitLog: {},
          },
        },

        // ========== ========== Page For Mission ========== ==========
        {
          name: "activity-coming",
          path: "activity-coming",
          component: () => import("@/components/activityComing.vue"),
          meta: {
            roleUser: ["Customer"],
            visitLog: {},
          },
        },
        {
          name: "activity-recommended",
          path: "activity-recommended",
          component: () => import("@/components/activityRecommended.vue"),
          meta: {
            roleUser: ["Customer"],
            visitLog: {},
          },
        },
        {
          name: "mission-detail",
          path: "missiondetail/:id/:status",
          component: () => import("@/views/Customer/Mission/MissionDetail"),
          beforeEnter: async (to, from, next) => {
            const userExist = await checkUserExist(to);
            if (userExist) {
              next();
            } else {
              next({ name: "check-login" });
            }
          },
          meta: {
            roleUser: ["Customer"],
            visitLog: {
              params: {
                id: "mission_id",
                status: "mission_status",
              },
            },
          },
        },
        {
          name: "mission-upload",
          path: "missionupload/:id",
          component: () => import("@/views/Customer/Mission/MissionUpload"),
          meta: {
            roleUser: ["Customer"],
            visitLog: {
              params: {
                id: "employee_mission_id",
              },
            },
          },
        },
        {
          name: "mission-checkin",
          path: "missioncheckin/:id",
          component: () => import("@/views/Customer/Mission/MissionCheckIn"),
          meta: {
            roleUser: ["Customer"],
            visitLog: {
              params: {
                id: "employee_mission_id",
              },
            },
          },
        },
        {
          name: "mission-survey",
          path: "missionsurvey/:id",
          component: () => import("@/views/Customer/Mission/MissionSurvey"),
          meta: {
            roleUser: ["Customer"],
            visitLog: {
              params: {
                id: "employee_mission_id",
              },
            },
          },
        },
        {
          name: "mission-lucky-draw",
          path: "missionluckydraw/:id",
          component: () => import("@/views/Customer/Mission/MissionLuckyDraw"),
          meta: {
            roleUser: ["Customer"],
            visitLog: {
              params: {
                id: "employee_mission_id",
              },
            },
          },
        },
        {
          name: "my-mission-detail",
          path: "mymission/detail/:id",
          component: () => import("@/views/Customer/Mission/MyMissionDetail"),
          meta: {
            roleUser: ["Customer"],
            visitLog: {
              params: {
                id: "employee_mission_id",
                status: "mission_status",
              },
            },
          },
        },
        {
          name: "top-ranking",
          path: "top-ranking/:id",
          component: () => import("@/views/Customer/Mission/TopRanking"),
          meta: {
            roleUser: ["Customer"],
            visitLog: {
              params: {
                id: "mission_id",
              },
            },
          },
        },
        // ========== ========== Page For My Account ========== ==========
        {
          name: "my-history",
          path: "history",
          component: () => import("@/views/Customer/History/MyHistory"),
          meta: {
            roleUser: ["Customer"],
            visitLog: {},
          },
        },
        {
          name: "privacy",
          path: "privacy",
          component: () => import("@/views/Customer/Setting/Privacy"),
          meta: {
            roleUser: ["Customer"],
            visitLog: {},
          },
        },
        {
          name: "favorite-item",
          path: "favorite-item",
          component: () => import("@/views/Customer/Favorite/FavoritePage"),
          meta: {
            roleUser: ["Customer"],
            visitLog: {},
          },
        },
        {
          name: "list-address",
          path: "list-address",
          component: () => import("@/views/Customer/Address/ListAddress"),
          meta: {
            roleUser: ["Customer"],
            visitLog: {},
          },
        },
        {
          name: "my-coupons",
          path: "my-coupons",
          component: () => import("@/views/Customer/MyCoupons/MyCoupons"),
          meta: {
            roleUser: ["Customer"],
            visitLog: {},
          },
        },
        {
          name: "history-coupon",
          path: "history-coupon",
          component: () => import("@/views/Customer/MyCoupons/HistoryMyCoupon"),
          meta: {
            roleUser: ["Customer"],
            visitLog: {},
          },
        },
        {
          name: "history-code",
          path: "history-code",
          component: () => import("@/views/Customer/History/HistoryCode"),
          meta: {
            roleUser: ["Customer"],
            visitLog: {},
          },
        },
        {
          name: "my-lucky-draws",
          path: "my-lucky-draws",
          component: () => import("@/views/Customer/MyAccount/MyLuckyDraws"),
          meta: {
            roleUser: ["Customer"],
            visitLog: {},
          },
        },
        {
          name: "level-detail",
          path: "level-detail",
          component: () => import("@/views/Customer/MyAccount/LevelDetail"),
          meta: {
            roleUser: ["Customer"],
            visitLog: {},
          },
        },
        {
          name: "my-member",
          path: "my-member",
          component: () => import("@/views/Customer/Member/MyMember"),
          meta: {
            roleUser: ["Customer"],
            visitLog: {},
          },
        },
        {
          name: "my-point",
          path: "my-point",
          component: () => import("@/views/Customer/MyPoint/MyPoint"),
          meta: {
            roleUser: ["Customer"],
            visitLog: {},
          },
        },
        {
          name: "register-member",
          path: "register-member",
          component: () => import("@/views/Customer/Member/RegisterMember"),
          meta: {
            roleUser: ["Customer"],
            visitLog: {},
          },
        },
        {
          name: "my-tag",
          path: "my-tag",
          component: () => import("@/views/Customer/MyAccount/MyTag"),
          meta: {
            roleUser: ["Customer"],
            visitLog: {},
          },
        },
        {
          name: "my-tag-detail",
          path: "my-tag-detail/:id",
          component: () => import("@/views/Customer/MyAccount/MyTagDetail"),
          meta: {
            roleUser: ["Customer"],
            visitLog: {
              params: {
                id: "tag_id",
              },
            },
          },
        },
        {
          name: "transfer",
          path: "transfer",
          component: () => import("@/views/Customer/Transfer/TransferPage"),
          meta: {
            roleUser: ["Customer"],
            visitLog: {},
          },
        },

        // ========== ========== Page For Blog Reward Shipment Other ========== ==========
        {
          name: "all-blog",
          path: "all-blog",
          component: () => import("@/components/allBlog.vue"),
          meta: {
            roleUser: ["Customer"],
            visitLog: {},
          },
        },
        {
          name: "blog",
          path: "blog/:id",
          component: () => import("@/views/Customer/Blog/Blog"),
          meta: {
            roleUser: ["Customer"],
            visitLog: {
              params: {
                id: "blog_id",
              },
            },
          },
        },
        {
          name: "reward-so-hot",
          path: "reward-so-hot",
          component: () => import("@/views/Customer/Reward/RewardSoHot"),
          meta: {
            roleUser: ["Customer"],
            visitLog: {},
          },
        },
        {
          name: "birthday-gift",
          path: "birthday-gift",
          component: () => import("@/views/Customer/Reward/RewardBirthDayGift"),
          meta: {
            roleUser: ["Customer"],
            visitLog: {},
          },
        },
        {
          name: "reward-partner",
          path: "reward-partner/:partner_code",
          component: () => import("@/views/Customer/Reward/RewardPartner"),
          meta: {
            roleUser: ["Customer"],
            visitLog: {},
          },
        },
        {
          name: "cancel-shipment",
          path: "cancel-shipment",
          component: () => import("@/views/Customer/Transport/CancelPage"),
          meta: {
            roleUser: ["Customer"],
            visitLog: {},
          },
        },

        // ========== ========== Page For Friend ========== ==========
        {
          name: "invite-friend",
          path: "invite-friend",
          component: () => import("@/views/Customer/Friend/Invite"),
          meta: {
            roleUser: ["Customer"],
            visitLog: {},
          },
        },
        {
          name: "friend-request",
          path: "friend-request",
          component: () => import("@/components/friend/listRequestFriend.vue"),
          meta: {
            roleUser: ["Customer"],
            visitLog: {},
          },
        },
        {
          name: "friend-list",
          path: "friend-list",
          component: () => import("@/components/friend/listFriend.vue"),
          meta: {
            roleUser: ["Customer"],
            visitLog: {},
          },
        },
        {
          name: "friend-recommend",
          path: "friend-recommend",
          component: () =>
            import("@/components/friend/listRecommendFriend.vue"),
          meta: {
            roleUser: ["Customer"],
            visitLog: {},
          },
        },
        {
          name: "friend-profile",
          path: "friend-profile/:id/:user_id",
          component: () => import("@/components/friend/profileFriend.vue"),
          meta: {
            roleUser: ["Customer"],
            visitLog: {
              params: {
                id: "friend_id",
                user_id: "user_id",
              },
            },
          },
        },

        // ========== ========== Page For Gamification ========== ==========
        {
          name: "gamification-all",
          path: "gamification-all",
          component: () =>
            import("@/views/Customer/Gamification/GamificationAll"),
          meta: {
            roleUser: ["Customer"],
            visitLog: {},
          },
        },
        {
          name: "gamification-detail",
          path: "gamification-detail/:id",
          component: () =>
            import("@/views/Customer/Gamification/GamificationDetail"),

          meta: {
            roleUser: ["Customer"],
            visitLog: {
              params: {
                id: "gamification_id",
              },
            },
          },
        },
        {
          name: "gamification",
          path: "gamification/:id",
          component: () => import("@/views/Customer/Gamification/Gamification"),
          meta: {
            roleUser: ["Customer"],
            visitLog: {
              params: {
                id: "gamification_id",
              },
            },
          },
        },
        {
          name: "gamification-history",
          path: "gamification-history/:id",
          component: () =>
            import("@/views/Customer/Gamification/GamificationHistory"),

          meta: {
            roleUser: ["Customer"],
            visitLog: {
              params: {
                id: "gamification_id",
              },
            },
          },
        },

        // ========== ========== Page Not Found ========== ==========
        {
          name: "page-not-found",
          path: "/",
          component: () => import("@/views/PageNotFound"),
          meta: {
            roleUser: [""],
            visitLog: {},
            unauthenticated: true,
          },
        },
        {
          name: "page-handle",
          path: "/",
          component: () => import("@/views/PageHandle"),
          meta: {
            roleUser: [""],
            visitLog: {},
            unauthenticated: true,
          },
        },

        // ========== ========== Page Edit Profile ========== ==========
        {
          name: "edit-profile",
          path: "edit-profile",
          component: () => import("@/views/Customer/MyAccount/EditProfile"),
          meta: {
            roleUser: ["Customer"],
            visitLog: {},
          },
        },

        // ========== ========== Page Campaign ========== ==========
        {
          name: "",
          path: "campaign",
          component: () => import("@/layouts/full-layout/Layout"),
          meta: { layout: "Layout" },
          children: [
            {
              name: "campaign-list",
              path: "/",
              component: () => import("@/views/Customer/Campaign/Campaign"),
              meta: {
                roleUser: ["Customer"],
                visitLog: {},
              },
            },
          ],
        },

        // ========== ========== Page Infomation Center ========== ==========
        {
          name: "",
          path: "information-center",
          component: () => import("@/layouts/full-layout/Layout"),
          meta: { layout: "Layout" },
          children: [
            {
              name: "information-center-list",
              path: "",
              component: () =>
                import("@/views/Customer/ReportAdminUser/InformationCenter"),
              meta: {
                roleUser: ["Customer"],
                visitLog: {},
              },
            },
          ],
        },
        {
          name: "",
          path: "information-center",
          component: () => import("@/layouts/blank-layout/Blanklayout"),
          meta: { layout: "Blanklayout" },
          children: [
            {
              name: "information-center-detail",
              path: "detail/:id",
              component: () =>
                import(
                  "@/views/Customer/ReportAdminUser/ReportAdminUserDetail"
                ),
              meta: {
                roleUser: ["Customer"],
                visitLog: {
                  params: {
                    id: "report_id",
                  },
                },
              },
            },
          ],
        },

        // ========== ========== Page Request ========== ==========
        {
          name: "",
          path: "request",
          component: () => import("@/layouts/full-layout/Layout"),
          meta: { layout: "Layout" },
          children: [
            {
              name: "request-list",
              path: "",
              component: () =>
                import("@/views/Customer/ReportAdminUser/Request"),
              meta: {
                roleUser: ["Customer"],
                visitLog: {},
              },
            },
          ],
        },
        {
          name: "",
          path: "request",
          component: () => import("@/layouts/blank-layout/Blanklayout"),
          meta: { layout: "Blanklayout" },
          children: [
            {
              name: "request-detail",
              path: "detail/:id",
              component: () =>
                import(
                  "@/views/Customer/ReportAdminUser/ReportAdminUserDetail"
                ),
              meta: {
                roleUser: ["Customer"],
                visitLog: {
                  params: {
                    id: "report_id",
                  },
                },
              },
            },
            {
              name: "new-request",
              path: "new",
              component: () =>
                import("@/views/Customer/ReportAdminUser/NewRequest"),
              meta: {
                roleUser: ["Customer"],
                visitLog: {},
              },
            },
            {
              name: "request-list-warranty-all",
              path: "request-list-warranty-all",
              component: () =>
                import("@/views/Customer/ReportAdminUser/RequestWarrantyAll"),
              meta: {
                roleUser: ["Customer"],
                visitLog: {},
              },
            },
          ],
        },

        // ========== ========== Page Warranty ========== ==========
        {
          name: "",
          path: "warranty",
          component: () => import("@/layouts/full-layout/Layout"),
          meta: { layout: "Layout" },
          children: [
            {
              name: "warranty-list",
              path: "",
              component: () => import("@/views/Customer/Warranty/WarrantyList"),
              meta: {
                roleUser: ["Customer"],
                visitLog: {},
              },
            },
          ],
        },
        {
          name: "",
          path: "warranty",
          component: () => import("@/layouts/blank-layout/Blanklayout"),
          meta: { layout: "Blanklayout" },
          children: [
            {
              name: "warranty-detail",
              path: "detail/:id",
              component: () =>
                import("@/views/Customer/Warranty/WarrantyDetail"),
              meta: {
                roleUser: ["Customer"],
                visitLog: {
                  params: {
                    id: "warranty_registration_id",
                  },
                },
              },
            },
            {
              name: "warranty-registration",
              path: "registration",
              component: () =>
                import("@/views/Customer/Warranty/WarrantyRegistration"),
              meta: {
                roleUser: ["Customer"],
                visitLog: {},
              },
            },
          ],
        },

        // ========== ========== Page Other ========== ==========
        {
          name: "",
          path: "other",
          component: () => import("@/layouts/full-layout/Layout"),
          meta: { layout: "Layout" },
          children: [
            {
              name: "other",
              path: "/",
              component: () => import("@/views/Customer/Other/OtherPage"),
              meta: {
                roleUser: ["Customer"],
                visitLog: {},
              },
            },
          ],
        },

        // ========== ========== Page Chat Room ========== ==========
        {
          name: "",
          path: "chat-room",
          component: () => import("@/layouts/full-layout/Layout"),
          meta: { layout: "Layout" },
          children: [
            {
              name: "chat-room-list",
              path: "",
              component: () =>
                import("@/views/Customer/Chat/ChatRoom"),
              meta: {
                roleUser: ["Customer"],
                visitLog: {},
              },
            },
          ],
        },
        // {
        //   name: "",
        //   path: "chat-room",
        //   component: () => import("@/layouts/blank-layout/Blanklayout"),
        //   meta: { layout: "Blanklayout" },
        //   children: [
        //     {
        //       name: "chat-room-detail",
        //       path: "detail/:id",
        //       component: () =>
        //         import(
        //           "@/views/Customer/ReportAdminUser/ReportAdminUserDetail"
        //         ),
        //       meta: {
        //         roleUser: ["Customer"],
        //         visitLog: {
        //           params: {
        //             id: "report_id",
        //           },
        //         },
        //       },
        //     },
        //   ],
        // },
      ],
    },
    {
      path: "",
      component: () => import("@/layouts/full-layout/Layout"),
      meta: { layout: "Layout" },
      children: [
        {
          name: "main",
          path: "main",
          component: () => import("@/views/Customer/Main"),
          meta: {
            roleUser: ["Customer"],
            visitLog: {},
          },
        },
        {
          name: "mission",
          path: "mission",
          component: () => import("@/views/Customer/Mission/Mission"),
          meta: {
            roleUser: ["Customer"],
            visitLog: {},
          },
        },
        {
          name: "my-mission",
          path: "mymission/:status",
          component: () => import("@/views/Customer/Mission/MyMission"),
          meta: {
            roleUser: ["Customer"],
            visitLog: {
              params: {
                status: "mission_status",
              },
            },
          },
        },
        {
          name: "reward",
          path: "reward",
          component: () => import("@/views/Customer/Reward/RewardPage"),
          meta: {
            roleUser: ["Customer"],
            visitLog: {},
          },
        },
        {
          name: "transport",
          path: "transport",
          component: () => import("@/views/Customer/Transport/TransportPage"),
          meta: {
            roleUser: ["Customer"],
            visitLog: {},
          },
        },
        {
          name: "my-account",
          path: "account",
          component: () => import("@/views/Customer/MyAccount/MyAccount"),
          meta: {
            roleUser: ["Customer"],
            visitLog: {},
          },
        },
      ],
    },

    // ========== ========== Microsite ========== ==========
    {
      path: "/microsite",
      component: () => import("@/layouts/blank-layout/MicrositeBlanklayout"),
      children: [
        {
          name: "microsite-login",
          path: ":slug",
          component: () => import("@/views/Microsite/user/Login"),
          beforeEnter: clearMicrositeUserState,
          meta: {
            visitLog: {
              params: {
                slug: "slug",
              },
            },
          },
        },
        {
          name: "microsite-register",
          path: ":slug/register",
          component: () => import("@/views/Microsite/user/Register"),
          meta: {
            micrositeRole: ["Customer"],
            visitLog: {
              params: {
                slug: "slug",
              },
            },
          },
        },
        {
          name: "microsite-bill",
          path: ":slug/bill",
          component: () => import("@/views/Microsite/user/Bill"),
          meta: {
            micrositeRole: ["Customer"],
            visitLog: {
              params: {
                slug: "slug",
              },
            },
          },
        },
        {
          name: "microsite-code",
          path: ":slug/code",
          component: () => import("@/views/Microsite/user/Code"),
          meta: {
            micrositeRole: ["Customer"],
            visitLog: {
              params: {
                slug: "slug",
              },
            },
          },
        },
        {
          name: "microsite-game",
          path: ":slug/game",
          component: () => import("@/views/Microsite/user/Game"),
          meta: {
            micrositeRole: ["Customer"],
            visitLog: {
              params: {
                slug: "slug",
              },
            },
          },
        },
        {
          name: "microsite-thankyou-game",
          path: ":slug/thankyou-game",
          component: () => import("@/views/Microsite/user/ThankyouGame"),
          meta: {
            micrositeRole: ["Customer"],
            visitLog: {
              params: {
                slug: "slug",
              },
            },
          },
        },
        {
          name: "microsite-thankyou",
          path: ":slug/thankyou",
          component: () => import("@/views/Microsite/user/Thankyou"),
          meta: {
            micrositeRole: ["Customer"],
            visitLog: {
              params: {
                slug: "slug",
              },
            },
          },
        },
        {
          name: "microsite-announcement",
          path: ":slug/announcement",
          component: () => import("@/views/Microsite/user/Announcement"),
          meta: {
            micrositeRole: ["Customer"],
            visitLog: {
              params: {
                slug: "slug",
              },
            },
          },
        },
        {
          name: "microsite-edit_profile",
          path: ":slug/edit_profile",
          component: () => import("@/views/Microsite/user/EditProfile"),
          meta: {
            micrositeRole: ["Customer"],
            visitLog: {
              params: {
                slug: "slug",
              },
            },
          },
        },
        {
          name: "microsite-menu",
          path: ":slug/menu",
          component: () => import("@/views/Microsite/user/Menu"),
          meta: {
            micrositeRole: ["Customer"],
            visitLog: {
              params: {
                slug: "slug",
              },
            },
          },
        },
        {
          name: "microsite-history",
          path: ":slug/history",
          component: () => import("@/views/Microsite/user/History"),
          meta: {
            micrositeRole: ["Customer"],
            visitLog: {
              params: {
                slug: "slug",
              },
            },
          },
        },
        {
          name: "microsite-history-code",
          path: ":slug/history-code",
          component: () => import("@/views/Microsite/user/HistoryCode"),
          meta: {
            micrositeRole: ["Customer"],
            visitLog: {
              params: {
                slug: "slug",
              },
            },
          },
        },
        {
          name: "microsite-history-game",
          path: ":slug/history-game",
          component: () => import("@/views/Microsite/user/HistoryGame"),
          meta: {
            micrositeRole: ["Customer"],
            visitLog: {
              params: {
                slug: "slug",
              },
            },
          },
        },
        {
          name: "microsite-top-spender",
          path: ":slug/top-spender",
          component: () => import("@/views/Microsite/user/TopSpender"),
          meta: {
            micrositeRole: ["Customer", "TopSpenderCustomer"],
            visitLog: {
              params: {
                slug: "slug",
              },
            },
          },
        },
      ],
    },
    {
      name: "microsite-end",
      path: "/microsite/:slug/end",
      component: () => import("@/views/Microsite/user/End"),
      meta: {
        visitLog: {
          params: {
            slug: "slug",
          },
        },
      },
    },
    {
      name: "microsite-pause",
      path: "/microsite/:slug/pause",
      component: () => import("@/views/Microsite/user/Pause"),
      meta: {
        visitLog: {
          params: {
            slug: "slug",
          },
        },
      },
    },
    {
      name: "microsite-error",
      path: "/microsite/:slug/error",
      component: () => import("@/views/Microsite/Error"),
      meta: {
        visitLog: {},
      },
    },

    // ========== ========== Page Not Found ========== ==========
    {
      path: "*",
      name: "error",
      component: () => import("@/views/Error"),
      meta: {
        roleUser: [""],
        visitLog: {},
      },
      beforeEnter: (to, from, next) => {
        next({ name: "check-login" });
      },
    },
  ],
});

function clearMicrositeUserState(_to, _from, next) {
  store.commit("microsite/CLEAR_USER_STATE");
  return next();
}

router.beforeEach(async (to, from, next) => {
  let token = localStorage.getItem("token");
  let vuex = localStorage.getItem("vuex");
  const mcommerceUser = store?.state?.defaultSystem?.customer;
  // ========== ========== ========== ==========
  // บันทึก Route ก่อนหน้าไว้ใน Router Instance
  // ถ้า from.name มีค่า และไม่ใช่หน้าแรก '/'
  if (from && from.name && from.fullPath !== '/') {
    router.previousRoute = from;
  } else {
    router.previousRoute = null;
  }
  router.previousRouteFrom = from;
  if (to.name === "page-handle" || to.name === "page-not-found") {
    return next();
  }
  // ========== ========== Get Site Template ========== ==========
  const dataSite = await store.dispatch("defaultSystem/getSiteTemplate", {
    employee_id: mcommerceUser.id,
  });
  if (!dataSite.success) {
    if (dataSite.data.status === "error_not_found_web") {
      next({
        name: "page-not-found",
      });
    } else if (dataSite.data.status === "error_inactive") {
      next({
        name: "page-handle",
        query: { page: "inactive" },
      });
    } else {
      next({
        name: "page-handle",
        query: { page: "not_in_period" },
      });
    }
    return;
  }

  // ========== ========== Check Line Browser (No Token) ========== ==========
  let checkLineReload = "none";
  checkLineReload = reloadViaLine(to);

  // ========== ========== Microsite ========== ==========
  if (to.name.startsWith("microsite-")) {
    const query_phone = to.query.phone;
    const query_line_id = to.query.line_id;
    const userNps = store?.state?.defaultSystem?.userNps;
    if (userNps) {
      store.commit("defaultSystem/SET_USER_NPS", {
        ...userNps,
        is_microsite: true,
      });
    }
    // store.commit("microsite/SET_USER", {});
    if (query_phone && query_line_id) {
      let vuex_json = JSON.parse(vuex);
      if (!vuex_json.microsite) {
        vuex_json.microsite = {
          user: {
            query_phone,
            query_line_id
          }
        };
      }
      vuex_json.microsite.user = {
        query_phone,
        query_line_id
      };
      vuex = JSON.stringify(vuex_json);
    }
    // ========== ========== ========== ==========
    // 1) Validate Campaign
    // if (to.name === "microsite-error") {
    //   return next();
    // }
    if (to.name === "microsite-login" || to.name === "microsite-register") {
      await store.dispatch("microsite/getCampaign", to.params.slug);
    }
    const campaign = store?.state?.microsite?.campaign;
    // ========== ========== Sync Customer ========== ==========
    let sync_customer = false;
    if (mcommerceUser?.id && campaign?.is_sync_customer) {
      sync_customer = true;
    }
    const funcSetCommitSyncUser = () => {
      if (
        sync_customer &&
        ["microsite-login", "microsite-register"].includes(to.name)
      ) {
        const phone = mcommerceUser.phone;
        const name = mcommerceUser.name || "";
        const surname = mcommerceUser.surname || "";
        const line_id = mcommerceUser.line_id || "";
        const fullname = `${name} ${surname}`.trim();
        const detail = {
          phone: phone,
          fullname: fullname,
        };
        store.commit("microsite/SET_USER", {
          user: {
            phone: phone,
            fullname: fullname,
            line_id: line_id,
            detail: detail,
          },
        });
      }
    };
    // ========== ========== ========== ==========

    // status campaign
    const statusCampaign = await store.dispatch(
      "microsite/checkCampaignStatus",
    );

    if (statusCampaign === "error" && to.name !== "microsite-login") {
      return next({
        name: "microsite-login",
        params: { slug: to.params.slug },
      });
    } else if (
      !store.state.microsite.user &&
      to.name !== "microsite-login" &&
      to.name !== "microsite-register" &&
      to.name !== "microsite-thankyou" &&
      to.name !== "microsite-pause" &&
      to.name !== "microsite-end" &&
      to.name !== "microsite-announcement" &&
      to.name !== "microsite-edit_profile"
    ) {
      return next({
        name: "microsite-login",
        params: { slug: to.params.slug },
      });
    }
    const isShowRegister = store.state.microsite.campaign.is_show_register;
    const isShowBill = store.state.microsite.campaign.is_show_bill;
    const isShowGame = store.state.microsite.campaign.is_show_game;
    const isShowCode = store.state.microsite.campaign.is_show_code;
    const isShowAnnouncement =
      store.state.microsite.campaign.is_show_announcement;
    const isShowEditProfile =
      store.state.microsite.campaign.is_show_edit_profile;

    //check if campaign is survey and status is active and route is not register
    if (
      store.state.microsite.campaign.template.name === "Survey" &&
      statusCampaign == "active" &&
      to.name !== "microsite-register" &&
      to.name !== "microsite-thankyou"
    ) {
      next({
        name: "microsite-register",
        params: { slug: to.params.slug },
      });
      return;
    }
    //check if campaign is survey and status is active and route is register
    else if (
      store.state.microsite.campaign.template.name === "Survey" &&
      statusCampaign == "active" &&
      to.name === "microsite-register"
    ) {
      funcSetCommitSyncUser();
      next();
      return;
    } else if (
      store.state.microsite.campaign.template.name !== "Survey" &&
      statusCampaign == "active" &&
      to.name === "microsite-register" &&
      isShowRegister
    ) {
      funcSetCommitSyncUser();
      next();
      return;
    } else if (
      store.state.microsite.campaign.template.name !== "Survey" &&
      statusCampaign == "active" &&
      to.name === "microsite-announcement" &&
      isShowAnnouncement
    ) {
      next();
      return;
    } else if (
      store.state.microsite.campaign.template.name !== "Survey" &&
      statusCampaign == "active" &&
      to.name === "microsite-edit_profile" &&
      isShowEditProfile
    ) {
      next();
      return;
    } else if (to.name === "microsite-thankyou" && statusCampaign == "active") {
      next();
      return;
    } else if (to.name === "microsite-menu" && statusCampaign == "active") {
      next();
      return;
    } else if (to.name === "microsite-history" && statusCampaign == "active") {
      next();
      return;
    } else if (
      to.name === "microsite-history-code" &&
      statusCampaign == "active"
    ) {
      next();
      return;
    } else if (
      to.name === "microsite-top-spender" &&
      statusCampaign == "active"
    ) {
      next();
      return;
    } else if (
      to.name === "microsite-bill" &&
      statusCampaign == "active" &&
      isShowBill
    ) {
      next();
      return;
    } else if (
      to.name === "microsite-code" &&
      statusCampaign == "active" &&
      isShowCode
    ) {
      next();
      return;
    } else if (
      to.name === "microsite-game" &&
      statusCampaign == "active" &&
      isShowGame
    ) {
      next();
      return;
    } else if (
      to.name === "microsite-thankyou-game" &&
      statusCampaign == "active"
    ) {
      next();
      return;
    } else if (
      to.name === "microsite-history-game" &&
      statusCampaign == "active"
    ) {
      next();
      return;
    }
    //check if status is active and route is not login
    else if (statusCampaign == "active" && to.name !== "microsite-login") {
      if (sync_customer && !isShowRegister && to.name == "microsite-end") {
        next();
        return;
      }
      next({
        name: "microsite-login",
        params: { slug: to.params.slug },
      });
      return;
    }
    // check if status is pause and route is not pause
    else if (statusCampaign == "pause" && to.name !== "microsite-pause") {
      next({
        name: "microsite-pause",
        params: { slug: to.params.slug },
      });
      return;
    }
    // check if status is not start and route is not end
    else if (statusCampaign == "not_start" && to.name !== "microsite-pause") {
      next({
        name: "microsite-pause",
        params: { slug: to.params.slug },
      });
      return;
    }
    // check if status is end and route is not end
    else if (statusCampaign == "end" && to.name !== "microsite-end") {
      next({
        name: "microsite-end",
        params: { slug: to.params.slug },
      });
      return;
    }

    //if status is not pause and route is pause
    if (
      to.name === "microsite-pause" &&
      statusCampaign != "pause" &&
      statusCampaign != "not_start"
    ) {
      next({
        name: "microsite-login",
        params: { slug: to.params.slug },
      });
      return;
    }

    // // 2) Validate User Roles
    if (to.meta.micrositeRole && to.meta.micrositeRole.includes("Customer")) {
      if (!store.state.microsite.user) {
        next({
          name: "microsite-login",
          params: { slug: to.params.slug },
        });
        return;
      } else if (to.meta.micrositeRole.includes("TopSpenderCustomer")) {
        if (
          store.state.microsite.campaign.template.name !==
          "Bill-luckydraw-top-spender"
        ) {
          next({
            name: "microsite-error",
            params: { slug: to.params.slug },
          });
          return;
        }
      }
    }

    // ========== ========== Check Sync Customer ========== ==========
    if (
      sync_customer &&
      ["microsite-login", "microsite-register"].includes(to.name)
    ) {
      const phone = mcommerceUser.phone;
      const micrositeUser = await store.dispatch("microsite/checkPhoneNumber", {
        campaignId: campaign.id,
        phone: phone,
      });
      if (micrositeUser) {
        return next({
          name: "microsite-menu",
          params: { slug: to.params.slug },
        });
      } else {
        if (!isShowRegister) {
          return next({
            name: "microsite-end",
            params: { slug: to.params.slug },
          });
        } else {
          funcSetCommitSyncUser();
          return next({
            name: "microsite-register",
            params: { slug: to.params.slug },
          });
        }
      }
    }
    // ========== ========== ========== ==========
    return next();
  }
  // ========== ========== Set Code ========== ==========
  const lineId = JSON.parse(vuex || "{}")?.defaultSystem?.userLine?.userId || null;
  // ต้องครอบด้วย lineId ก่อน เพราะ LINE Login จะส่ง query code กลับมา
  // ซึ่งไปชนกับ code ที่ระบบ scan ใช้งานอยู่ ทำให้ dialog scan ถูกเปิด
  if (!lineId) {
    const code = localStorage.getItem("code");
    if (![undefined, null, "", "undefined"].includes(to.query?.code)) {
      localStorage.setItem("code", to.query.code);
    } else if (code && ![undefined, null, "", "undefined"].includes(code)) {
      localStorage.setItem("code", code);
    }
  } else {
    localStorage.setItem("code", "");
  }
  // ========== ========== Third Party ========== ==========
  const user_token = to.query?.user_token || null;
  const app_key = to.query?.app_key || null;
  if (user_token && app_key) {
    await exchangeTokenThirdParty(user_token, app_key);
    next();
    setTimeout(() => {
      const url = new URL(window.location.href);
      url.searchParams.delete("user_token");
      url.searchParams.delete("app_key");
      window.history.replaceState({}, "", url.pathname + url.search);
    }, 100);
    return;
  }
  // ========== ========== MCommerce ========== ==========
  const query_token = to.query?.token || null;
  const unauthenticated = to.meta.unauthenticated;
  const prev_route_full_path = to.fullPath;
  const prev_route_full_path_storage = localStorage.getItem("prev_route_full_path");
  if (!token && !query_token && !unauthenticated) {
    const is_logout = localStorage.getItem("is_logout");
    if (!prev_route_full_path_storage && !is_logout) {
      localStorage.setItem("prev_route_full_path", prev_route_full_path);
    }
    localStorage.removeItem("is_logout");
    next({ name: "check-login" });
    return;
  }
  logVisit(to, store.state.defaultSystem);
  // ========== ========== Check Account Type : Multi Profile ========== ==========
  const site = store.state.defaultSystem?.site;
  if (
    site?.account_type == "multi_profile" &&
    to.name != "select-profile" &&
    token
  ) {
    const multiProfileSelect = store.state.defaultSystem?.multiProfileSelect;
    if (!multiProfileSelect || Object.keys(multiProfileSelect).length === 0) {
      return next({ name: "select-profile" });
    }
  } else {
    store.commit("defaultSystem/SET_MULTI_PROFILE_SELECT", {});
  }
  // ========== ========== Check Line Browser (Token) ========== ==========
  checkLineReload = addParamAndReloadViaLine(to);
  // ========== ========== Check Token Query ========== ==========
  if (!token && query_token) {
    localStorage.setItem("token", query_token);
    next();
    setTimeout(() => {
      const url = new URL(window.location.href);
      url.searchParams.delete("token");
      window.history.replaceState({}, "", url.pathname + url.search);
    }, 100);
    return;
  }
  // ========== ========== ========== ==========
  if (token) {
    if (
      ["individual", "group_account"].includes(site?.account_type) ||
      (site?.account_type == "multi_profile" && to.name != "select-profile")
    ) {
      await store.dispatch("defaultSystem/getProfile");
      store.dispatch("defaultSystem/getNotification");
    }
    // ========== ========== NPS ========== ==========
    const customer = store?.state?.defaultSystem?.customer;
    const userNps = store?.state?.defaultSystem?.userNps;
    const parentRoute = to.matched.length > 0 ? to.matched[0] : null;
    if (parentRoute?.meta?.layout == "Layout") {
      store.commit("defaultSystem/SET_USER_NPS", {
        ...userNps,
        nps_alert: false,
        is_microsite: false,
      });
      if (customer.code != userNps.employee_code) {
        store.commit("defaultSystem/SET_USER_NPS", {
          nps_alert: false,
        });
      }
      getProfileNPS();
    } else {
      store.commit("defaultSystem/SET_USER_NPS", {
        ...userNps,
        nps_alert: false,
        is_microsite: false,
      });
    }
  }

  // ========== ========== ========== ==========
  if (to.params.status == "campaign") {
    const platform = to.query.platform === undefined ? "" : to.query.platform;
    let path = to.path;
    if (platform) {
      path = to.fullPath;
    }
    store.commit("login/SET_URL_REDIRECT", { urlRedirect: path });
    store.commit("defaultSystem/SET_USER", { role: "Customer" });
    store.commit("friend/SET_INVITE", to.query.invite ?? "");
    store.commit("friend/SET_PLATFORM", platform);
  } else if (to.name == "mission-detail" || to.name == "my-mission-detail") {
    store.commit("friend/SET_PLATFORM", "");
  }
  let role = store.state.defaultSystem.user;
  let roleName = "";
  if (role == null) {
    roleName = "Unknown";
  } else {
    roleName = role.role;
  }
  if (!to.meta.roleUser[0]) {
    return next();
  }

  let checkRoleRoutes = to.meta.roleUser
    ? to.meta.roleUser.includes(roleName)
    : false;

  if (checkLineReload == "active") {
    return;
  }
  if (checkRoleRoutes) {
    // ========== for true next route
    if (token && prev_route_full_path_storage) {
      // if have prev route
      localStorage.removeItem("prev_route_full_path");
      return next(prev_route_full_path_storage);
    }
    return next();
  } else {
    if (checkLineReload == "none") {
      const is_logout = localStorage.getItem("is_logout");
      if (!prev_route_full_path_storage && !is_logout) {
        localStorage.setItem("prev_route_full_path", prev_route_full_path);
      }
      localStorage.removeItem("is_logout");
      return next({ name: "check-login" });
    } else {
      return next();
    }
  }
});

export default router;
